import BaseModel from './BaseModel';

export default class TrustUpIOTask extends BaseModel
{

    init(data)
    {
        super.init(data);

        this.due_date_date = this.due_date ? window.moment(this.due_date).toDate() : null;

        if ( this.users ) {
            this.setUsers(
                this.users.map(user => {
                    return window.App.$store.state.models.users.find(u => u.id == user.id);
                })
            );
        }
    }

    static getPrefix()
    {
        return 'trustup-io-task:task';
    }

    getEndpoint()
    {
        return window.TrustUpBase.endpoints.trustupIOTask;
    }

    data() {
        return {
            id: this.id,
            uuid: this.uuid,
            app_key: this.app_key,
            is_done: this.is_done,
            done_at: this.done_at,
            is_having_due_date_time: this.is_having_due_date_time,
            model_id: this.model_id,
            model_type: this.model_type,
            title: this.title,
            users: this.users,
            due_date: this.due_date,
            professional_authorization_key: window.App.$store.state.user.default_professional.authorization_key,
            account_uuid: window.App.$store.state.account.uuid,
        }
    } 

    setUsers(users)
    {
        this.users = users;
        this.users_id = users.map(user => user.id);
    }

    setUsersByID(ids)
    {
        this.setUsers(
            ids.map(id => {
                return window.App.$store.state.models.users.find(user => user.id == id);
            })
        );
    }
    
    setDueDateFromDate()
    {
        if ( this.due_date_date == 'Invalid date' || this.due_date == 'Invalid date' ) {
            this.due_date = this.due_date_date = null;
            return;
        }

        this.due_date = this.due_date_date ? window.moment(this.due_date_date).format('YYYY-MM-DD') : null;
    }

}